import { render, staticRenderFns } from "./PFViolationReport.vue?vue&type=template&id=c80266fa&"
import script from "./PFViolationReport.vue?vue&type=script&lang=js&"
export * from "./PFViolationReport.vue?vue&type=script&lang=js&"
import style0 from "./PFViolationReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80266fa')) {
      api.createRecord('c80266fa', component.options)
    } else {
      api.reload('c80266fa', component.options)
    }
    module.hot.accept("./PFViolationReport.vue?vue&type=template&id=c80266fa&", function () {
      api.rerender('c80266fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PFViolationReport.vue"
export default component.exports